import React from 'react';
import { Phone, MessageCircle, AtSign } from 'lucide-react';
import { BRAND } from '../utils/constants';
import './MobileCTA.css';

export default function MobileCTA() {
  return (
    <div className="mobile-cta-bar">
      <a href={`tel:${BRAND.phone}`} className="mcta-btn call">
        <Phone size={18} />
        <span>Call</span>
      </a>
      <a
        href={`https://wa.me/${BRAND.whatsapp}?text=Hi! I'm interested in joining The Physique Factory.`}
        target="_blank"
        rel="noopener noreferrer"
        className="mcta-btn whatsapp"
      >
        <MessageCircle size={18} />
        <span>WhatsApp</span>
      </a>
      <a
        href={BRAND.instagramUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mcta-btn instagram"
      >
        <AtSign size={18} />
        <span>Instagram</span>
      </a>
    </div>
  );
}
